import axios from 'axios';
const API = process.env.REACT_APP_API_BASE_URL;


//login
export const loginUser = async (formData) => {
    try{
        return await axios.post(
            `${API}/adminAuth/login`, formData);
    }catch(error){
        console.error("login failed: ", error);
        throw error;
   }
   
};

// Add customer
export const addCustomer = async (formData) => {
    try {
        const token = localStorage.getItem('token'); //  get token from localStorage
        const response = await axios.post(`${API}/adminContacts/addCustomer`, formData, {
            headers: {
                Authorization: `Bearer ${token}` //  send token in headers
            }
        });
        
        return response.data;
    } catch (error) {
        console.error("add customer failed: ", error);
        throw error;
    }
};

//save user and password from settings
export const saveUser = async (formData) => {
  try {
      const token = localStorage.getItem('token'); 
      const response = await axios.post(`${API}/adminContacts/saveUser`, formData, {
          headers: {
              Authorization: `Bearer ${token}` 
          }
      });
      return response.data;
  } catch (error) {
      console.error("save user failed: ", error);
      throw error;
  }
};

//fetch saved clients
export const fetchClients = async () => {
  try {
      const token = localStorage.getItem('token'); 
      const response = await axios.get(`${API}/adminContacts/clients`, {
          headers: {
              Authorization: `Bearer ${token}` 
          }
      });
      return response.data;
  } catch (error) {
      console.error("fetch clients failed: ", error);
      throw error;
  }
};

//update client
export const updateClient = async (formData) => {
  try {
      const token = localStorage.getItem('token'); 
      const response = await axios.post(`${API}/adminContacts/updateClient`, formData, {
          headers: {
              Authorization: `Bearer ${token}` 
          }
      });
      return response.data;
  } catch (error) {
      console.error("update client failed: ", error);
      throw error;
  }
};